import lib from "../js-lib/lib.js";
import cacher from "../js-lib/cacher.js";
import { _$ } from "../js-lib/jsr.js";

const cookies = {
  load_cache: (state) => {
    if (!state.cookies || !state) {
      return;
    }

    // Load cache - See the previous state of cookies
    state["cookies"] = cacher.retrieve("cookies")
      ? cacher.retrieve("cookies")
      : state.cookies;
  },
  render: (state) => {
    // IF admin, do not show
    if (lib.qs(".logged_in")) {
      return;
    }

    if (state.cookies.enabled === true) {
      cookies.accepted(state);
      return;
    }

    if (state.cookies.enabled === false) {
      cookies.declined(state);
      return;
    }

    if (!state.cookies || !state || lib.id("#cookies-notice")) {
      return;
    }

    // Create initial notice
    let _$cookie = _$.create(
      `<div id="cookies-notice">
        <div class="site-width">
        <p>
        We use cookies to analyse our traffic and related technologies such as pixel tags. To give your consent for the use of this technology, please click accept.</p>
        <div id="cookies-options">
        </div>
        </div>
      </div>`,
      "body",
      1
    );

    // Accept Behaviour
    let accept = _$.create(
      `<button id="cookies-accept">
            Accept
       </button>`,
      "#cookies-options",
      2
    );

    // Decline Behaviour
    let decline = _$.create(
      `<button id="cookies-decline">
            Decline
        </button>`,
      "#cookies-options",
      3
    );

    accept.addEventListener("click", () => {
      cookies.accept(state);

      _$cookie.remove();
    });

    decline.addEventListener("click", () => {
      cookies.decline();

      _$cookie.remove();
    });
  },
  accept: (state) => {
    // Cookie Enabled Scripts
    state.cookies.enabled = true;
    cacher.store("cookies", state.cookies);
  },
  accepted: (state) => {
    console.log("cookies are accepted!");
  },
  decline: () => {
    // Actions to take on a Decline

    state.cookies.enabled = false;
    cacher.store("cookies", state.cookies);
  },
  declined: () => {
    console.log("cookies are declined.");
  },
};

export { cookies as default };
